// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2GAsK","ranges":"BmiRanges_ranges__1QLOP"};